module.exports = __webpack_public_path__ + "static/media/trash.f4c19668.svg";